import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Route, Routes } from 'react-router-dom'
import {
  DetailHistoryRouletteDialog,
  PlayerFinancialHistory,
  PlayerGameSessionResultsDialog,
  PlayerTransactionsDialog,
} from '../components'
import { AdminLayout, AuthLayout, Common } from '../layouts'
import {
  BalanceSheetRequest,
  Bonuses,
  Games,
  HistoryRoulette,
  Limits,
  Login,
  ManageGameRoulette,
  ManageGameRussianPoker,
  NoMatch,
  Operators,
  Payouts,
  Players,
  Recording,
  Recordings,
  RouletteSocketPlayerEvents,
  RpGameSessionDetails,
  RpGameSessions,
  Stands,
} from '../pages'
import { useStore } from '../stores'
import PrivateRoute from './PrivateRoute'
import RoleAccess from './RoleAccess'
import routes from './routes'

const Router: FC = observer(() => {
  const { loginStore } = useStore()

  return (
    <Routes>
      <Route element={<Common />}>
        <Route element={<AuthLayout />}>
          <Route path={routes.login} element={<Login />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Games />} />
            <Route
              path={routes.operators}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <Operators />
                </RoleAccess>
              }
            />
            <Route
              path={routes.players}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <Players />
                </RoleAccess>
              }
            />
            <Route
              path={routes.recordings}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <Recordings />
                </RoleAccess>
              }
            />
            <Route
              path={routes.recordingWithId}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <Recording />
                </RoleAccess>
              }
            />
            <Route
              path={routes.balanceSheetRequests}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <BalanceSheetRequest />
                </RoleAccess>
              }
            />
            <Route
              path={routes.limits}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <Limits />
                </RoleAccess>
              }
            />
            <Route
              path={routes.bonuses}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <Bonuses />
                </RoleAccess>
              }
            />
            <Route
              path={routes.stands}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <Stands />
                </RoleAccess>
              }
            />
            <Route
              path={routes.payouts}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <Payouts />
                </RoleAccess>
              }
            />
            <Route
              path={routes.historyRouletteById}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <HistoryRoulette />
                </RoleAccess>
              }
            />

            <Route
              path={`${routes.playerFinancialHistory}`}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <PlayerFinancialHistory />
                </RoleAccess>
              }
            />
            <Route
              path={routes.playerGameSessionResults}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <PlayerGameSessionResultsDialog />
                </RoleAccess>
              }
            />
            <Route
              path={routes.playerTransactions}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <PlayerTransactionsDialog />
                </RoleAccess>
              }
            />
            <Route
              path={routes.detailRouletteSession}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <DetailHistoryRouletteDialog />
                </RoleAccess>
              }
            />
            <Route
              path={routes.rouletteSocketPlayerEvents}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <RouletteSocketPlayerEvents />
                </RoleAccess>
              }
            />

            <Route
              path={routes.prpSessionsById}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <RpGameSessions />
                </RoleAccess>
              }
            />

            <Route
              path={routes.prpSessionDetails}
              element={
                <RoleAccess isAllowed={loginStore.isRoleAM}>
                  <RpGameSessionDetails />
                </RoleAccess>
              }
            />
          </Route>

          <Route path={routes.manageGameRouletteById} element={<ManageGameRoulette />} />
          <Route path={routes.manageGameRussianPokerById} element={<ManageGameRussianPoker />} />
        </Route>

        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
  )
})

export default Router
